















































































































import Vue from "vue";
import Component from "vue-class-component";
import { UserStore, RoleStore } from "@/store";
import {
  AuthenticateUserCommand,
  UserDto,
  UserType
} from "@/api/AuthenticationApiClient";
import { ROUTES } from "@/router";

@Component
export default class LoginForm extends Vue {
  private username: string = "";
  private password: string = "";
  public pincode: string = "";
  private show2FactAuthForm: boolean = false;
  private pinCodeState: boolean | null = null;
  private passwordState: boolean | null = null;
  private isAdvisor: boolean = false;
  private isContact: boolean = false;
  private user!: UserDto;
  private codeSentMessage: boolean = false;
  public async onClick2FactLogin(event: MouseEvent) {
    event.preventDefault();

    const valid = await this.ValidateFactAuth(this.username, this.pincode);

    if (valid === false) {
      this.pinCodeState = false;
      // this.passwordState = false;
    } else {
      const result = await UserStore.Login(this.user);
    }
  }
  public async onClickValidateTwoFact6DigitCodeLogin(event: MouseEvent) {
    event.preventDefault();
    const valid = await this.ValidateTwoFact6DigitCodeAuth(
      this.pincode,
      this.username
    );

    if (valid === false) {
      this.pinCodeState = false;
      //this.passwordState = false;
    } else {
      const result = await UserStore.Login(this.user);
    }
  }
  public async GenerateTwoFact6DigitCode() {
    //event.preventDefault();

    const valid = await this.Generate6DigitCodeTwoFactAuth(this.username);

    this.codeSentMessage = true;

    setTimeout(() => {
      this.codeSentMessage = false;
    }, 3000); // 3000ms = 3 seconds
  }

  public async onClickLogin(event: MouseEvent) {
    event.preventDefault();

    this.user = await UserStore.AuthenticateUser(
      new AuthenticateUserCommand({
        username: this.username,
        password: this.password,
        databaseId: UserStore.companyDatabaseId
      })
    );
    if (this.user === null) {
      this.passwordState = false;
      return;
    } else {
      this.passwordState = true;
    }
    this.isAdvisor = this.user.userType === UserType.ContactOwner;
    this.isContact = this.user.userType === UserType.Contact;
    if (this.isAdvisor) {
      const twoFactEnabled = await this.Is2FAEnabled(this.username);
      if (twoFactEnabled === false) {
        this.show2FactAuthForm = false;
        const result = await UserStore.Login(this.user);
      } else {
        if (this.show2FactAuthForm === false) {
          this.show2FactAuthForm = true;
        } else await this.onClick2FactLogin(event);
      }
    } else if (this.isContact) {
      const twoFactEnabled = this.user.twoFactorEnabled;
      if (!twoFactEnabled) {
        this.show2FactAuthForm = true;
        const result = await UserStore.Login(this.user);
      } else {
        if (this.show2FactAuthForm === false) {
          this.show2FactAuthForm = true;
          await this.GenerateTwoFact6DigitCode();
        } else await this.onClickValidateTwoFact6DigitCodeLogin(event);
      }
    } else {
      const result = await UserStore.Login(this.user);
    }
  }

  async ValidateFactAuth(userName: string, pinCode: string) {
    // var companyID = 1;
    var FactorAuthUrl;
    var token = {
      Username: userName,
      Pincode: pinCode
    };

    FactorAuthUrl =
      "https://wealthtrackwebservices.com/wtdataservice/WTDataService.svc/validate2FactorAuthByUsernameAndPincode";

    const raw = JSON.stringify(token);
    const requestOptions = {
      body: raw,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    };
    const response = await fetch(FactorAuthUrl, requestOptions);
    const valid = await response.json();
    return valid;
  }
  async ValidateTwoFact6DigitCodeAuth(pinCode: string, userName: string) {
    // var companyID = 1;
    var FactorAuthUrl;
    var token = {
      Username: userName,
      Pincode: pinCode
    };

    FactorAuthUrl =
      "https://wealthtrackwebservices.com/wtdataservice/WTDataService.svc/ValidateTwoFA6DigitCode";

    const raw = JSON.stringify(token);
    const requestOptions = {
      body: raw,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    };
    const response = await fetch(FactorAuthUrl, requestOptions);
    const valid = await response.json();
    return valid;
  }
  async Generate6DigitCodeTwoFactAuth(userName: string) {
    // var companyID = 1;
    var FactorAuthUrl;
    var token = {
      Username: userName
    };

    FactorAuthUrl =
      "https://wealthtrackwebservices.com/wtdataservice/WTDataService.svc/GenerateTwoFA6DigitCode";

    const raw = JSON.stringify(token);
    const requestOptions = {
      body: raw,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    };
    const response = await fetch(FactorAuthUrl, requestOptions);
    const valid = await response.json();
    return valid;
  }
  async Is2FAEnabled(userName: string): Promise<boolean> {
    // var companyID = 1;
    var FactorAuthUrl;
    var token = {
      Username: userName
    };

    FactorAuthUrl =
      "https://wealthtrackwebservices.com/wtdataservice/WTDataService.svc/CheckIs2FactAuthenticationByUsername";

    const raw = JSON.stringify(token);
    const requestOptions = {
      body: raw,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    };
    const response = await fetch(FactorAuthUrl, requestOptions);
    const twoFactEnabled = await response.json();
    return twoFactEnabled;
  }

  get companyLogo(): string {
    return UserStore.companyLogo;
  }

  get companyName(): string {
    return UserStore.companyName;
  }

  get forgotPasswordRoute(): string {
    return ROUTES.forgotPassword;
  }

  get isExternalBroker(): boolean {
    return RoleStore.isExternalBroker;
  }
}
